import { Card, CardContent, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';

const MainAuthorsBooksList = ({mainAuthorsFormStore: store}) => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h2" component="h2">{store.formData['name']}</Typography>
        <Table>
          <TableHead>
            <TableCell>ID</TableCell>
            <TableCell>Título do livro</TableCell>
            <TableCell> Qtde. de trechos vinculados</TableCell>
          </TableHead>
          <TableBody>
            {store.books.map(book => {
              return (
                <TableRow key={book.id}>
                  <TableCell>{book.id}</TableCell>
                  <TableCell>{book.title}</TableCell>
                  <TableCell>{book.count_quotes}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>

      </CardContent>
    </Card>
  );
}

export default MainAuthorsBooksList;
